"use client"

import { forwardRef, type Ref } from "react"
import { clsx } from "clsx"

import type { PropsWithClassName } from "~/@types/generics"
import { AbstractSkeleton } from "~/components/abstracts/Skeleton/index.client"
import { useTranslate } from "~/providers/I18nProvider/hooks/useTranslate"

import * as css from "./styles.css"

function ForwardedProductCardSkeleton({ className }: PropsWithClassName, ref: Ref<HTMLDivElement>) {
  const t = useTranslate()

  return (
    <div ref={ref} className={clsx(className, css.cardContent, css.skeleton)}>
      <div className={css.cover}>
        <AbstractSkeleton />
      </div>

      <div className={css.baseline}>
        <p className={css.title}>
          <AbstractSkeleton />
          {t("general_loading")}
          {t("general_loading")}
          {t("general_loading")}
        </p>
        <p className={css.price}>
          <AbstractSkeleton />
          {t("general_loading")}
        </p>
      </div>
    </div>
  )
}

export const ProductCardSkeleton = forwardRef(ForwardedProductCardSkeleton)
